import React from 'react'
import cx from 'classnames'

const SendButton = ({
  emailButtonLabel,
  onClick,
  isSaved,
  className,
  sendEmailButtonActive,
  disabled,
  hasSegmentsSelected,
}) => (
  <button
    className={cx('drift-button', 'drift-button-primary', className)}
    disabled={!sendEmailButtonActive || !isSaved || disabled || !hasSegmentsSelected}
    onClick={onClick}
  >
    {emailButtonLabel}
  </button>
)

export default SendButton



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/SendButton/component.js